<template lang="pug">
  v-container
    h3.mb-4 Расписание
    v-row
      v-col(cols="12" lg="8")
        .mb-4
          select-course(
            v-model="course"
            placeholder="Поиск курсов"
            solo
            clearable
            hide-details
            :serverDataAttrs="params"
          )

        server-data(
          ref="recommendationList"
          :method="$api.telegram.conferenceIndex"
          :query="query"
          v-slot="{ serverData, loading }"
        )
          data-wrapper(
            :loading="loading"
            :skeleton-items-count="4"
            :has-items="!!serverData.length"
            skeleton-type="paragraph"
            :colsProps="{ cols: 12, md: 12, sm: 12, xl: 12 }"
          )
            template(#no-data)
              .d-flex
                span.text-body-1.mt-2.pl-4 Еще нет уроков...

                v-btn.ml-auto(
                  v-if="$user.isTeacher"
                  color="primary" large text
                  :to="{ name: 'ConferenceCreate' }"
                ).mt-n2
                  span Создать видеотрансляцию
                  v-icon(right) mdi-plus
            template(#default)
              v-list
                template(
                  v-for="item in serverData"
                )
                  .d-flex.align-center
                    .text-subtitle-1.primary--text: strong {{ item.date_start | dp('dd MMMM')}}
                    v-divider().ml-8
                  lessons-calendar-item.pb-3(
                    :key="item.id"
                    :lesson="item"
                  )

</template>

<script>

import {
  format,
} from 'date-fns';

import SelectCourse from '@/components/InputFields/course/SelectCourse.vue';
import LessonsList from '../components/LessonsList.vue';
import LessonsCalendarItem from '../components/LessonsCalendarItem.vue';

export default {
  components: {
    LessonsCalendarItem,
    SelectCourse,
    LessonsList,
  },
  data: () => ({
    course: null,

  }),
  computed: {
    query() {
      const today = format(new Date(), 'yyyy-MM-dd');
      const query = {
        sort: 'date_start',
        'per-page': -1,
        'search[from_date]': today,
        'search[course_id]': this.courseId,
        ...this.$user.isTeacher ? {
          'search[teacher_id]': this.$user.studentMode ? null : this.$user.data.teacher_id,
          'search[im_learning]': this.$user.studentMode || null,
          'search[me_and_open]': this.$user.studentMode || null,
        } : {
          'search[me_and_open]': true,
        },
        expand: 'users,groups,prior_records,courses',
      };
      return query;
    },

    params() {
      const isStudent = this.$user.studentMode || this.$user.isStudent;
      return {
        query: {
          ...isStudent ? { 'search[trained]': this.$user.data.id } : { 'search[teacher_or_curator]': this.$user.data.id },
        },
      };
    },
    courseQuery() {
      if (!this.$route.meta.trained) {
        return { 'search[teacher]': this.$user.data.id };
      }
      return { 'search[trained]': true };
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule {
  position: relative;

  &__calendar {
    padding-right: 400px;
    width: 100%;
    transition: padding-right 0.1s cubic-bezier(0.25, 1, 0.5, 1);

    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  &__calendar.full {
    display: block;
    padding-right: 0;
  }
  &__lessons {
    position: absolute;
    padding-left: 10px;
    top: 0;
    right: 0;
    width: 400px;

    @media screen and (max-width: 768px) {
      padding-left: 0px;
      width: 100%;
    }
  }
}
</style>
